<template>
  <form
    class="modal-content"
    @submit.prevent="submit"
  >
    <div class="modal-content__wrapper">
      <h3 class="modal-title">{{ title }}</h3>
      <p class="modal-text">{{ text }}</p>

      <div
        v-for="field in modalData"
        :key="field.name"
        class="form-group"
      >
        <label
          class="form-label"
          :for="field.name"
        >
          {{ field.title }}
        </label>

        <select
          v-if="field.type === 'select'"
          v-model="form[field.name]"
          :id="field.name"
          class="form-input"
        >
          <option
            value="-1"
            disabled
          >
            {{ field.placeholder }}
          </option>

          <option
            v-for="(fieldOption, index) in field.values"
            :key="`${fieldOption[field.itemValue]}-${index}`"
            :value="fieldOption[field.itemValue]"
          >
            {{ fieldOption[field.itemText] }}
          </option>
        </select>

        <textarea
          v-else-if="field.type === 'textarea'"
          :id="field.name"
          v-model="form[field.name]"
          :placeholder="field.placeholder"
          class="form-input"
        />

        <input
          v-else
          :id="field.name"
          v-model="form[field.name]"
          :placeholder="field.placeholder"
          class="form-input"
          :type="field.type"
        />
      </div>

      <div
        v-if="error"
        class="modal-error"
      >
        {{ error }}
      </div>
    </div>

    <div class="modal-actions">
      <button
        type="button"
        class="modal-button modal-button--cancel"
        @click="closeModal(null)"
      >
        {{ textCancelBtn }}
      </button>

      <button
        type="submit"
        class="modal-button modal-button--confirm"
        :disabled="canCreate"
      >
        {{ textConfirmBtn }}
      </button>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'

import pickBy from 'lodash/pickBy'
import isEqual from 'lodash/isEqual'

import moment from 'moment'

export default {
  name: 'CreateBase',
  props: {
    name: {
      type: String,
      default: ''
    },
    moduleAction: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    textCancelBtn: {
      type: String,
      default: ''
    },
    textConfirmBtn: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: {},
      modalData: null,
      isSubmitting: false,
      error: null
    }
  },
  computed: {
    canCreate () {
      return this.modalData
        && Object.entries(this.modalData).some(([, value]) => {
          if (value.type === 'checkbox') {
            return false
          }

          return value?.required && (!this.form[value.name] || this.form[value.name] === -1)
        }) || this.isSubmitting
    }
  },
  mounted () {
    this.seedForm()
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    ...mapActions('settings', ['loadModalData']),
    async seedForm () {
      this.$bus.emit('start-loader')

      const { data, error } = await this.loadModalData({
        name: this.name,
        type: this.type
      })

      if (error) {
        this.$notify({
          type: 'error',
          title: 'Ошибка при загрузке данных!',
          text: 'Произошла ошибка при загрузке полей для модального окна!',
          clean: false,
          duration: 3000
        })

        this.$bus.emit('stop-loader')

        await this.closeModal(null)
      }

      const getValue = (type, value, defaultValue) => {
        if (!value) {
          return defaultValue
        }

        if (type === 'date') {
          return moment(value).format('DD.MM.YYYY')
        }

        if (
          typeof value === 'string'
          || typeof value === 'number'
          || type === 'checkbox'
        ) {
          return value
        }

        return value.code
      }

      this.modalData = data
      this.modalData.forEach(({ name, defaultValue, type }) => {
        const value = Object.prototype.hasOwnProperty.call(this.data, name)
          ? this.data[name]
          : defaultValue

        this.$set(this.form, name, getValue(type, value, defaultValue))
      })


      this.$bus.emit('stop-loader')
    },
    async submit () {
      const baseObject = this.modalData.reduce((acc, { name, defaultValue }) => {
        acc[name] = Object.prototype.hasOwnProperty.call(this.data, name)
          ? this.data[name]
          : defaultValue

        return acc
      }, {})

      const shallowDiff = pickBy(this.form, (value, key) => !isEqual(baseObject[key], value))

      if (Object.keys(shallowDiff).length === 0) {
        this.$notify({
          type: 'warning',
          title: 'Упс!',
          text: 'Данные не изменены',
          clean: false,
          duration: 3000
        })

        return
      }

      this.isSubmitting = true

      const { error } = await this.$store.dispatch(`${this.moduleAction}/change`, {
        id: this.data.id,
        data: shallowDiff
      })

      this.isSubmitting = false

      if (error) {
        this.error = `Произошла ошибка: ${error.message}`

        return
      }

      this.$notify({
        type: 'success',
        title: 'Успех!',
        text: 'Данные успешно обновлены!',
        clean: false,
        duration: 3000
      })

      await this.closeModal(null)
    }
  }
}
</script>

<style lang="scss" src="./style.scss" scoped />